import { DocType } from '@/models/docs';

import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select';

interface LeasingDocTypeComboBoxProps {
    value: string;
    onChange: (value: DocType) => void;
    disabled?: boolean;
}

// TODO: Move this to Documents/DocumentsPanel when cleaning up
export function LeasingDocTypeComboBox({
    value,
    onChange,
    disabled,
    ...props
}: LeasingDocTypeComboBoxProps) {
    return (
        <Select
            value={value}
            onValueChange={(val) => onChange(val as DocType)}
            disabled={disabled}
            {...props}
        >
            <SelectTrigger
                data-testid="LeasingDocTypeComboBox__trigger"
                className="border rounded px-2 py-1 text-sm w-full"
            >
                <SelectValue placeholder="Select document type" />
            </SelectTrigger>
            <SelectContent>
                {Object.entries(DocType).map(([key, val]) => (
                    <SelectItem
                        key={val}
                        value={val}
                        data-testid="LeasingDocTypeComboBox__item"
                    >
                        {key
                            .replace(/_/g, ' ')
                            .replace(/\b\w/g, (c) => c.toUpperCase())}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}
